const defaultWeather = {
    "coord": {
        "lon": 85.1167,
        "lat": 25.6
    },
    "weather": [
        {
            "id": 721,
            "main": "Haze",
            "description": "haze",
            "icon": "50d"
        }
    ],
    "base": "stations",
    "main": {
        "temp": 299.11,
        "feels_like": 299.11,
        "temp_min": 299.11,
        "temp_max": 299.11,
        "pressure": 1016,
        "humidity": 24
    },
    "visibility": 5000,
    "wind": {
        "speed": 2.57,
        "deg": 300
    },
    "clouds": {
        "all": 0
    },
    "dt": 1638950900,
    "sys": {
        "type": 1,
        "id": 9129,
        "country": "IN",
        "sunrise": 1638924824,
        "sunset": 1638962959
    },
    "timezone": 19800,
    "id": 1260086,
    "name": "Patna",
    "cod": 200
}

export default defaultWeather